import clsx from "clsx"
import NextImage from "next/image"
import { tailwindScreenSize } from "@/utilities/ui/get-tailwind-config"

type NewsletterSignUpImageProps = {
  readonly className?: string
}

export function NewsletterSignUpImage({
  className,
}: NewsletterSignUpImageProps) {
  return (
    <div
      className={clsx(
        "relative h-full sm:[clip-path:polygon(20%_0,100%_0,100%_100%,0%_100%)]",
        className,
      )}
    >
      <NextImage
        alt=""
        className="select-none object-cover mix-blend-multiply"
        draggable={false}
        fill={true}
        sizes={`(max-width: ${tailwindScreenSize.md}) 340px, 650px`}
        src="/images/newsletter/newsletter-sign-up-background.png"
      />
    </div>
  )
}
